<template>
  <div class="ChatExpertList" v-loading="isPageLoading">
    <MobileNav :page_title="nav_title" :filter_count="selectedFilterCount" />

    <!-- Left Section: Filters -->
    <div class="filters-section" v-if="isDesktop">
      <Filters @update-filter-count="updateFilterCount" :filters="filters" />
    </div>

    <!-- Right Section: Expert List with Search Input -->
    <div class="expert-list-section">
      <div class="flex-space-between">
        <el-input v-model="searchTerm" placeholder="Search experts by name" class="search-input" clearable size="small">
          <template slot="suffix" v-if="!searchTerm">
            <i class="el-icon-search search-icon"></i>
          </template>
        </el-input>

        <div class="flex-center" v-if="!isDesktop">
          <img class="mobile-filter cursor-pointer" src="../assets/images/filter.svg" alt="" @click="openFilterDialog()" />
          <!-- <div v-if="filterCount" class="filter-count">{{ filterCount }}</div> -->
        </div>
      </div>

      <ChatExpertCard :experts="filteredExperts" @updateIsExpertBusyPopup="isExpertBusyPopupVisible = $event" @updateIsStartChatPopup="handleStartChatDialog" @updateChatPlanDetailsPopup="handlePricingPlanDetailsDialog" />

      <!-- btn to load more recos -->
      <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_expert_list_loading" @click="loadMoreExperts()">Load more</div>

      <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_expert_list_loading">
        <div class="text-center">
          <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
        </div>
      </div>
    </div>

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>

    <!-- experience category dialog -->
    <el-dialog :visible.sync="isExperienceCategoryDialogVisible" class="start-chat-popup" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <!-- <i class="el-icon-error cursor-pointer" @click="isExperienceCategoryDialogVisible = false"></i> -->
      <img src="../assets/images/closeIcon.svg" class="close-icon cursor-pointer" @click="isExperienceCategoryDialogVisible = false" />

      <div class="popup-content">
        <!-- Title and Partition Line -->
        <h3 class="popup-title">What Best Describes You?</h3>
        <div class="partition-line"></div>

        <!-- Buttons (Beginner, Investor, Trader) -->
        <div class="button-group">
          <button class="category-btn" size="large" :class="{ active: selectedCategory === 'Beginner' }" @click="selectCategory('Beginner')">Beginner</button>
          <button class="category-btn" size="large" :class="{ active: selectedCategory === 'Investor' }" @click="selectCategory('Investor')">Investor</button>
          <button class="category-btn" size="large" :class="{ active: selectedCategory === 'Trader' }" @click="selectCategory('Trader')">Trader</button>
        </div>

        <!-- Compulsory Checkbox -->
        <div class="agreement-text">
          <el-checkbox v-model="isAgreementAccepted" style="margin-right: 7px"></el-checkbox>
          <p>I agree that the SEBI Expert can only guide me using the skills and expertise mentioned. I understand and accept the limitations of the SEBI Expert. I acknowledge that the expert is not responsible for any profits or losses, and I will take full responsibility for conducting my own research before making any investment or trading decisions.</p>
        </div>

        <!-- Chat Button -->
        <div class="chat-btn-container">
          <el-button class="chat-btn" :disabled="!selectedCategory" @click="saveInvestmentProfile()" :loading="isInvestMentProfileLoading">Start Chat</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- chat initiated dialog -->
    <el-dialog :visible.sync="isChatInitiatedPopupVisible" class="start-chat-popup chat-initiated" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="popup-content">
        <div class="loading-div" v-loading="isChatInitiatedLoading"></div>
        <h4>Chat Initiated</h4>

        <div v-if="!isRequestTimeExpired">
          Expert will take
          <span style="color: #2488ff">1-2 mins to accept Chat Request</span>
        </div>

        <div v-if="isRequestTimeExpired">
          We apologize for the delay. You may
          <span style="color: #2488ff; cursor: pointer; text-decoration: underline" @click="cancelChatRequest()">cancel</span>
          this request and submit a new one to connect with another expert
        </div>
      </div>
    </el-dialog>

    <!-- request accepted chat dialog -->
    <div class="top-drawer">
      <el-drawer :visible.sync="chatAcceptedDrawer" direction="ttb" custom-class="chat-accepted-drawer" :modal="false" :show-close="false">
        <div class="main-div">
          <div class="check-outer flex">
            <i class="el-icon-check"></i>
            <div>
              <div class="name">
                {{ selectedExpertForChat.full_name }}
              </div>
              <div class="duration">15 Min Duration</div>
            </div>
          </div>

          <div class="waiting-time-section">
            <i class="el-icon-time"></i>
            <div>
              <div class="head">Please wait</div>
              <div class="sub-text">Expert is connecting</div>
              <div class="sub-text">Don't close the app</div>
            </div>
          </div>
        </div>
        <img src="../assets/images/closeIcon.svg" class="close-icon cursor-pointer" @click="openCloseConfirmationPopup()" />
      </el-drawer>
    </div>

    <!-- chat plan details dialog -->
    <div class="bottom-drawer">
      <el-drawer :visible.sync="chatPlanDetailsPopup" direction="btt" custom-class="chat-drawer" :modal="false">
        <div class="flex-center">
          <img src="../assets/images/ChatImages/Group 5515.svg" alt="" class="floating-image-wrapper" />
        </div>

        <!-- Left and Right Sections -->
        <div class="drawer-content">
          <!-- Left Section -->
          <div class="left-section">
            <div class="inner-content">
              <h2 class="drawer-heading">“Connect with SEBI Expert Anytime Now”</h2>
              <!-- <p class="drawer-subtext">Unlock SEBI Expert Advice Anytime, Anywhere with</p> -->

              <div class="details-list">
                <div class="points">
                  <i class="el-icon-success"></i>
                  Live 15 Mins Chat
                </div>
                <div class="points">
                  <i class="el-icon-success"></i>
                  Connect Instant with SEBI Experts
                </div>
                <div class="points">
                  <i class="el-icon-success"></i>
                  Real Time Guidance
                </div>
              </div>
            </div>
          </div>

          <!-- Right Section: Table and Subscribe -->
          <div class="right-section">
            <div class="inner-content">
              <!-- Pricing Table with Radio Buttons -->

              <!-- <div class="pricing-table">
                <div class="flex-space-between table-titles">
                  <div>Select Plan</div>
                  <div>Validity</div>
                </div>
                <div class="pricing-row" v-for="(option, index) in chatPackages" :key="index" :class="{ 'active-row': selectedPackage === option.label }">
                  <div class="pricing-column">
                    <el-radio v-model="selectedPackage" :label="option.label">
                      {{ option.label }}
                    </el-radio>
                  </div>
                  <div class="pricing-column price">
                    ₹ {{ option.price }}
                    <span style="font-size: 0.6rem; font-weight: 500">/Chat</span>
                  </div>
                  <div class="pricing-column duration">{{ option.duration }} Days</div>
                </div>
              </div> -->

              <div>
                <div class="plan-price">
                  ₹ {{ selectedChatPlan.price }}/
                  <span>{{ selectedChatPlan.duration }}min</span>
                </div>
                <!-- <div class="plan-price-sub">Prices may vary between off-market and During market hours.</div> -->
              </div>

              <!-- Subscribe Button -->
              <div class="flex-center">
                <el-button type="primary" class="full-width-btn" :disabled="!selectedPackage || !acceptTerms" @click="getOrderId()" :loading="is_purchase_plan_in_progress">Subscribe</el-button>
              </div>

              <!-- Terms and Conditions -->
              <div class="agreement-checkbox">
                <el-checkbox v-model="acceptTerms"></el-checkbox>
                <p>
                  I Accept
                  <router-link to="/retail-side/terms-condition" style="color: #2488ff">Terms and Conditions</router-link>
                  and
                  <a href="https://d3vvd51leqaoql.cloudfront.net/stockants_chat/chat_agreement.pdf" style="color: #2488ff">Chat Agreement</a>
                  .
                </p>
              </div>

              <div class="end-gray-txt">Above charges are StockAnts tech support charges for live interactive session with SEBI Expert.</div>

              <div class="chat-note">Note: This subscription will be valid for 15 days.</div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>

    <el-dialog :visible.sync="isCloseConfirmationPopupVisible" class="start-chat-popup confirmation-popup" :show-close="false">
      <div class="popup-content">
        <!-- Title and Partition Line -->
        <h5 class="popup-title">Are you sure you want to cancel this chat?</h5>
        <!-- Chat Button -->
        <div class="chat-btn-container">
          <el-button
            class="btn-light-blue-borderd right-margin-10"
            size="small"
            style="width: 95px"
            @click="
              isCloseConfirmationPopupVisible = false;
              isRequestCanceling = false;
            "
          >
            No
          </el-button>
          <el-button class="btn-light-blue-filled" :loading="isRequestCanceling" style="width: 95px" @click="cancelChatRequestConfirmed()">Yes</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="isExpertBusyPopupVisible" class="start-chat-popup confirmation-popup" :show-close="false">
      <div class="popup-content">
        <!-- Title and Partition Line -->
        <h4 class="popup-title" style="font-size: 15px; margin-bottom: 15px">Expert is Busy</h4>

        <p style="">Tap the bell, and we'll notify you when Expert is available.</p>
        <!-- Chat Button -->
        <div class="chat-btn-container expert-busy-btns">
          <el-button class="btn-light-blue-borderd right-margin-10" size="small" style="width: 95px; position: relative; top: -4px; padding: 9px 15px" @click="isExpertBusyPopupVisible = false">Close</el-button>
          <el-button class="btn-light-blue-filled" style="width: 95px" @click="isExpertBusyPopupVisible = false">
            <div class="flex-center">
              <img src="../assets/images/NotificationIcon.svg" alt="" style="margin-right: 5px" />
              Notify me
            </div>
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- chat initiated dialog -->
    <el-dialog :visible.sync="isChatRequestDialogVisible" class="start-chat-popup chat-initiated" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="popup-content">
        Currently Expert is not available

        <el-button class="btn-light-blue-filled top-margin-10" @click="isChatRequestDialogVisible = false">Check other Experts</el-button>
      </div>
    </el-dialog>

    <!-- chat error dialog -->
    <el-dialog :visible.sync="errorDialogVisible" class="start-chat-popup chat-initiated" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="popup-content">
        {{ errorMessage }}

        <el-button class="btn-light-blue-filled top-margin-10" @click="errorDialogVisible = false">OK</el-button>
      </div>
    </el-dialog>

    <ChatMobileFilterDialog :filters="filters" :filter_title="nav_title"></ChatMobileFilterDialog>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig.js';
import MobileNav from '@/components/MobileNav.vue';
import Filters from '@/components/ChatFilters.vue';
import ChatExpertCard from '@/components/ChatExpertCard.vue';
import ProcessKycComponent from '@/components/NewKycFlow.vue';
import { screenSize } from '../mixins/ScreenSize.js';
// import socket from '../mixins/WebSocket.js';
import { HelperNetworkCallBack } from '../mixins/Helper.js';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import ChatMobileFilterDialog from '@/components/MobileChatFilters.vue';
// enable it while integrating payment gateway
import cashfreePromise from '../mixins/cashfreeInit.js';
import CripNotice from 'crip-vue-notice';
import { credentials, cashfreeCredentials } from '../mixins/Credentials.js';
import { EventBus } from '../eventBus';

export default {
  components: {
    Filters,
    ChatExpertCard,
    MobileNav,
    ProcessKycComponent,
    ChatMobileFilterDialog,
  },

  mixins: [screenSize, HelperNetworkCallBack, updateProfileNetworkCallBack],

  data() {
    return {
      nav_title: 'Experts',
      searchTerm: '',
      experts: [],
      selectedFilterCount: 0,
      selectedExpertForChat: {},
      planSubscriptionStatusDetails: null,
      isExperienceCategoryDialogVisible: false,
      selectedCategory: 'Investor',
      isAgreementAccepted: false,
      isChatInitiatedPopupVisible: false,
      isChatInitiatedLoading: true,
      chatAcceptedDrawer: false,
      chatPlanDetailsPopup: false,
      selectedPackage: '1 Chat', // Radio button model to store the selected package

      acceptTerms: false, // Checkbox model for terms and conditions
      is_purchase_plan_in_progress: false,
      chatPackages: [
        { label: '1 Chat', price: 299, duration: 15, chatCount: 1 },
        { label: '3 Chats', price: 335, duration: 30, chatCount: 3 },
        { label: '5 Chats', price: 350, duration: 45, chatCount: 5 },
      ],
      selectedChatPlan: {
        label: '1 Chat',
        price: 299,
        duration: 15,
        chatCount: 1,
      },

      // for payment gateway only
      session_id: null,
      order_id: '',
      internalTeamMailList: ['joshiakshay7191office@gmail.com', 'chiragp0310@gmail.com', 'krishaa0801@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com', 'snehalvpatil25@gmail.com', 'sumittarkas0001@gmail.com', 'bid.pallavi@gmail.com', 'pallavi.bid@stockants.com', 'bhushanm705811@gmail.com', 'admin@stockants.com', 'sumittarkas001@gmail.com', 'satavchetan08@gmail.com', 'amanm3047@gmail.com', 'jadeanurag@gmail.com'],
      isCloseConfirmationPopupVisible: false,
      isExpertBusyPopupVisible: false,
      is_expert_list_loading: true,
      number_of_pages: 0,
      page_no: 1,
      isPageLoading: false,
      isInvestMentProfileLoading: false,
      timeWhenRequestSent: null,
      currentTime: null,
      timer: null,
      isRequestCanceling: false,
      isChatRequestDialogVisible: false,
      errorDialogVisible: false,
      errorMessage: '',
      filters: [
        {
          id: 1,
          title: 'Skills',
          filter: ['Fundamental Analysis', 'Technical Analysis', 'Short term Research', 'Long Term Research', 'Multibagger Specialist', 'IPO'],
        },
        {
          id: 2,
          title: 'Asset class',
          filter: ['Equity', 'F&O', 'Commodity', 'Market Overview', 'Penny stocks'],
        },
        {
          id: 3,
          title: 'Experience',
          filter: ['< 3years', '3-7years', '> 7years'],
        },
        {
          id: 4,
          title: 'Availability',
          filter: ['Online', 'Offline', 'Busy'],
        },
        // Add more filters as needed
      ],
    };
  },

  watch: {
    getPlanSubscriptionStatus(newValue, oldValue) {
      this.planSubscriptionStatusDetails = newValue.message;

      if (this.planSubscriptionStatusDetails && this.planSubscriptionStatusDetails.extra_info.transaction_status == 'SUCCESS') {
        if (this.planSubscriptionStatusDetails.data.plan == 'Publisher') {
          localStorage.setItem('publisher_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        } else {
          localStorage.setItem('plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        }
        this.$store.commit('commitKycDialog', true);
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('profile')) {
      setTimeout(() => {
        var userProfile = JSON.parse(localStorage.getItem('profile'));

        console.log(userProfile.profession, userProfile.profession != 'Retail Investor');

        if (userProfile && userProfile.profession != 'Retail Investor') {
          next({ name: 'DataCategorisation' });
        }
      }, 0);
    }
    next();
  },

  created() {
    this.getPlanDetails();

    this.getExpertList();
  },

  async mounted() {
    this.$socket.off('recent-chat'); // Remove previous listeners to prevent duplication
    this.$socket.off('room-joined');
    this.$socket.off('room-messages');
    this.$socket.off('is-user-typing');
    this.$socket.off('chat-message');
    this.$socket.off('errorValidation');
    this.$socket.off('room_status');

    this.timer = setInterval(() => {
      this.currentTime = this.getCurrentTime();
    }, 1000);

    this.$socket.on('is-request-accept', (data) => {
      // console.log('is-request-accept', data);
      this.isChatInitiatedPopupVisible = false;

      // if (this.userProfile && this.userProfile.profession == 'Retail Investor') {
      //   var autoGenerateMessage = 'Auto generated message NEWWWW ';
      //   console.log(autoGenerateMessage, 'autoGenerateMessage');

      //   this.$socket.emit('send_room_message', { room: this.roomId, message: autoGenerateMessage, sender_id: this.userProfile.id, is_read: false });
      // }

      // if session is already ongoing then restrict user to redirect to chat window
      // because if expert will join the new room then event will be emitted here and user will be redirected to chat page so restricted to redirect
      if (!localStorage.getItem('isSessionOngoing')) {
        this.chatAcceptedDrawer = true;

        this.$router.push({ path: '/chat_window' });
      }
    });

    // if user cancells request then callback from the chat server
    this.$socket.on('room_status', (data) => {
      console.log('room_status', data);

      this.isRequestCanceling = false;

      this.isCloseConfirmationPopupVisible = false;
      this.isChatInitiatedPopupVisible = false;

      this.isChatRequestDialogVisible = true;
      this.timeWhenRequestSent = null;
    });

    this.$socket.on('available-experts', (experts) => {
      if (experts.data.length) {
        this.experts = experts.data;
      } else {
        this.experts = [];
      }

      this.is_expert_list_loading = false;
    });

    this.$socket.on('errorValidation', (data) => {
      console.log('error from ChatExpertList Page:', data);

      this.isCloseConfirmationPopupVisible = false;
      this.isChatInitiatedPopupVisible = false;
      this.isChatRequestDialogVisible = false;

      this.errorDialogVisible = true;

      this.errorMessage = data && data.message ? data.message : '';
    });
  },

  methods: {
    //     let isExpired = false;

    // if (this.timeWhenRequestSent) {
    //   const givenTime = this.timeWhenRequestSent; // Example of a specific date and time

    //   // Calculate the difference in milliseconds
    //   let timeDifference = this.currentTime - givenTime;

    //   // Convert 1 minute to milliseconds (1 * 60 * 1000)(Min * Sec * 1000)
    //   const requestedTimeInSec = 1 * 15 * 1000;

    //   // Auto cancel request if requested time is more than 3 min
    //   const requestedTimeInMin = 3 * 60 * 1000;

    //   console.log(requestedTimeInSec);

    //   // Check if the current time is greater than 15 sec after the given time
    //   if (timeDifference > requestedTimeInSec) {
    //     isExpired = true;
    //   } else {
    //     isExpired = false;
    //   }

    // }
    // return isExpired;

    openFilterDialog() {
      console.log('openFilterDialog');

      EventBus.$emit('openFilterDialog');
    },

    openCloseConfirmationPopup() {
      this.isCloseConfirmationPopupVisible = true;
    },

    updateFilterCount(newCount) {
      this.selectedFilterCount = newCount;
    },

    async selectedUser(user) {
      try {
        console.log('selected expert from expert card', user);

        this.timeWhenRequestSent = null; //reset time
        this.chatAcceptedDrawer = false; //close chat request dialog

        if (user) {
          this.isInvestMentProfileLoading = false; //button loader

          this.isExperienceCategoryDialogVisible = false;
          this.isChatInitiatedPopupVisible = true;

          this.calculateRequestedTime();

          let roomIdData = await this.getRoomId(user.id);

          if (roomIdData.data.data && roomIdData.data.status) {
            this.$store.commit('commitRoomId', roomIdData.data.data.room_name);
            this.joinRoom(roomIdData.data.data.room_name);
          } else {
            console.log('No room details present');
            this.isInvestMentProfileLoading = false; //button loader
            this.isExperienceCategoryDialogVisible = false;
            this.isChatInitiatedPopupVisible = false;
          }
        } else {
          this.isInvestMentProfileLoading = false; //button loader
          this.isExperienceCategoryDialogVisible = false;
          throw new Error('No user id');
        }
      } catch (e) {
        this.isChatInitiatedPopupVisible = false;
        this.isInvestMentProfileLoading = false; //button loader
        this.isExperienceCategoryDialogVisible = false;
        console.log('Error in getting room details', e);
      }
    },
    calculateRequestedTime() {
      // Clear any previous timer
      if (this.autoCancelTimer) {
        clearTimeout(this.autoCancelTimer);
      }

      // Start auto-cancel timer for 3 minutes
      this.autoCancelTimer = setTimeout(() => {
        if (this.isChatInitiatedPopupVisible) {
          console.log('Auto-canceling request after 3 minutes');
          this.cancelChatRequestConfirmed(); // Call your cancel function
          this.isChatInitiatedPopupVisible = false;
        }
      }, 3 * 60 * 1000); // 3 minutes in ms
    },

    // handle chat pricing plan dialog
    handlePricingPlanDetailsDialog(event) {
      this.selectedPackage = '1 Chat';
      this.acceptTerms = false;
      this.chatPlanDetailsPopup = event;
    },

    //handle start chat dialog
    handleStartChatDialog(expert) {
      // console.log("handleStartChatDialog", expert)
      // if user has already selected profile category then bypass it
      this.selectedExpertForChat = expert;

      if (this.userProfile.extra_info && this.userProfile.extra_info.investment_profile && this.userProfile.extra_info.investment_profile.length) {
        if (this.checkIsSessionOngoing() && this.selectedExpertForChat.status == 'Ongoing') {
          console.log('no need to join rom redirecting to chat page');

          this.$router.push({ path: '/chat_window' });
        } else {
          this.selectedUser(this.selectedExpertForChat);
        }
      } else {
        // reset values on dialog open
        this.selectedCategory = null;
        this.isAgreementAccepted = false;
        this.isExperienceCategoryDialogVisible = true;
      }
    },

    getRoomId(user_id) {
      return serverAddr.post('chat/v1/room', { user_id: user_id }).then((response) => {
        console.log('getRoomIds', response);
        return response;
      });
    },

    saveInvestmentProfile() {
      // this.isInvestMentProfileLoading = true; //button loader

      if (this.isAgreementAccepted) {
        localStorage.setItem('userProfileCategory', this.selectedCategory);
        serverAddr
          .post('/auth/v1/partial_profile_update', {
            investment_profile: this.selectedCategory,
          })
          .then((response) => {
            if (response.data.status) {
              this.getProfileCallBack(response);

              this.selectedUser(this.selectedExpertForChat);

              // this.isExperienceCategoryDialogVisible = false;
              // this.isChatInitiatedPopupVisible = true;

              // setTimeout(() => {
              //   this.isChatInitiatedPopupVisible = false;
              //   this.chatAcceptedDrawer = true;

              //   this.selectedUser(this.selectedExpertForChat);
              // }, 3000);
              localStorage.setItem('userProfileCategory', this.selectedCategory);
            } else {
              this.isInvestMentProfileLoading = false; //button loader
            }
          })
          .catch((error) => {
            console.log(error);
            this.isInvestMentProfileLoading = false; //button loader
          });
      } else {
        new CripNotice({
          title: 'Oops! Something went wrong!',
          description: 'Accept StockAnts Agreement before process',
          type: 'error',
          duration: 3,
        });
      }
    },

    selectCategory(category) {
      this.selectedCategory = category;
    },

    async joinRoom(room) {
      try {
        this.timeWhenRequestSent = new Date();

        console.log('joining new room');

        localStorage.removeItem('isSessionOngoing');

        this.$socket.emit('join_room', { room: room, user_id: this.userProfile.id });
      } catch (e) {
        console.log('error in joining room');

        this.isChatInitiatedPopupVisible = false;
        this.timeWhenRequestSent = null;
      }

      // this.$router.push({ path: "/chat_window" });
      // return new Promise((resolve, reject) => {
      //   this.$socket.emit('join_room', { room : "1" }, (response) => {
      //     if (response && response.status === 'joined') {
      //       console.log(`Successfully joined room: ${response.room}`);

      //       if(response.room){
      //         this.$store.commit("commitRoomId", response.room);
      //       }

      //       this.$router.push( { path: "/chat_window" } );
      //       resolve(response);
      //     } else {
      //       reject(new Error('Failed to join room'));
      //     }
      //   });
      // });
    },

    loadMoreExperts() {
      this.page_no = this.page_no + 1;
      // this.number_of_pages = null;     //to disable load more tab
      // this.getExpertList();
    },

    cancelChatRequest() {
      this.isCloseConfirmationPopupVisible = true;
    },

    async cancelChatRequestConfirmed() {
      try {
        this.isRequestCanceling = true; //button loader

        setTimeout(async () => {
          await this.$socket.emit('cancel_room_status', { room: this.roomId, user_id: this.userProfile.id });
        }, 2000);

        // this.isCloseConfirmationPopupVisible = false;
        // this.isChatInitiatedPopupVisible = false;
        // this.timeWhenRequestSent = null;
      } catch (e) {
        this.isRequestCanceling = false; //button loader
        console.log('Error in cancelling request', e);
      }
    },

    getCurrentTime() {
      // Return formatted current time (you can adjust format as needed)
      return new Date();
    },

    async getExpertList() {
      try {
        await this.$socket.emit('expert_list', {});
      } catch (e) {
        console.log('error in getting expert list');
        this.is_expert_list_loading = false;
      }
      // serverAddr
      //   .get(`/user/admin/chat_expert_list?page_number=${this.page_no}&page_per_entries=4`)
      //   .then((response) => {
      //     if (response.data.status && response.data.data.length) {
      //       this.number_of_pages = response.data.pagination.total_pages;
      //       this.page_no = response.data.pagination.current_page

      //       // Append new data to the existing list
      //       this.experts.push(...response.data.data);

      //       // this is hardcoded value and need to remove
      //       this.experts[0].status = 'busy'

      //     } else {
      //       this.experts = [];
      //     }
      //     this.is_expert_list_loading = false;

      //   })
      //   .catch(
      //     function (error) {
      //       this.is_expert_list_loading = false;
      //       console.log(error);
      //     }.bind(this)
      //   );
    },

    getPlanDetails() {
      serverAddr
        .post('/stockants_pro/get-user-subscription/', {})
        .then((response) => {
          if (response.data.status) {
            let stockAntsChatPlan = response.data.data.find((plan) => plan.plan === 'StockAnts Chat');

            stockAntsChatPlan = stockAntsChatPlan ? stockAntsChatPlan : {};

            // Save Publisher plan details
            this.$store.commit('commitChatPlanDetails', stockAntsChatPlan);
            this.saveSubscribedChatPlanDetails(stockAntsChatPlan);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getOrderId() {
      this.is_purchase_plan_in_progress = true; //display button loader

      // filter selected chat plan
      // this.selectedChatPlan = this.chatPackages.find((plan) => plan.label === this.selectedPackage);

      var currentPrice = this.selectedChatPlan.price * this.selectedChatPlan.chatCount;

      if (this.internalTeamMailList.includes(this.userProfile.email)) {
        currentPrice = 1;
      }

      serverAddr
        .post('/payment/v3/generate_order_id/', {
          plan_name: 'StockAnts Chat',
          days: this.selectedChatPlan.duration,
          amount: currentPrice,
          order_category_id: 4,
          description: 'Plan Subscription',
          pg: 'CASHFREE',
        })
        .then((response) => {
          if (response.data.status && Object.keys(response.data.data).length) {
            this.order_id = response.data.data.order_id; //getting order id
            this.session_id = response.data.data.session_id;

            // init  payment mode
            this.initCashfree();
          } else {
            new CripNotice({
              title: 'Oops! Something went wrong!',
              description: 'Please try again',
              type: 'error',
              duration: 3,
            });
          }

          this.is_purchase_plan_in_progress = false; //disabled loader
          this.chatPlanDetailsPopup = false;
        })
        .catch(
          function (error) {
            console.log(error);

            this.order_id = '';
            this.is_purchase_plan_in_progress = false; //disabled loader
            this.chatPlanDetailsPopup = false;

            new CripNotice({
              title: 'Oops! Something went wrong!',
              description: 'Please try again',
              type: 'error',
              duration: 3,
            });
          }.bind(this)
        );
    },

    async initCashfree() {
      try {
        // Wait for the cashfreePromise to resolve, which contains the initialized Cashfree SDK
        const cashfree = await cashfreePromise;

        // Check if this.session_id is defined and not empty
        if (!this.session_id) {
          console.error('Error: paymentSessionId is missing or undefined');

          new CripNotice({
            title: 'Oops! Something went wrong!',
            description: 'Please try again',
            type: 'error',
            duration: 3,
          });

          return; // Exit the function if session_id is missing or undefined
        }

        // Construct options for checkout
        const checkoutOptions = {
          paymentSessionId: this.session_id,
          appId: cashfreeCredentials.appId,
          orderId: this.order_id,
          orderAmount: this.selectedChatPlan.price * this.selectedChatPlan.chatCount,
          // orderAmount: this.validity
          //   ? credentials.PREMIUM_COST_THIRTY_DAYS
          //   : credentials.PREMIUM_COST_SEVEN_DAYS,

          orderCurrency: 'INR',
          customerName: credentials.NAME,
          redirectTarget: '_modal',
          // Add other necessary options
        };

        // Initiate payment using checkout
        cashfree.checkout(checkoutOptions).then((result) => {
          console.log('result', result);
          if (result.error) {
            // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
            new CripNotice({
              title: result.error.message,
              description: 'Check for Payment Status',
              type: 'error',
              duration: 3,
            });

            console.log('User has closed the popup, Check for Payment Status', result.error);
          }

          if (result.redirect) {
            // This will be true when the payment redirection page couldnt be opened in the same window
            // This is an exceptional case only when the page is opened inside an inAppBrowser
            // In this case the customer will be redirected to return url once payment is completed
            console.log('Payment will be redirected');
          }

          if (result.paymentDetails) {
            // This will be called whenever the payment is completed irrespective of transaction status
            console.log('Payment has been completed, Check for Payment Status', result);

            // this.is_confirm_plan_purchase_dialog_visible = false;
            // console.log(result.paymentDetails.paymentMessage);
            new CripNotice({
              title: 'Payment received!',
              description: 'Please wait till confirm',
              type: 'success',
              duration: 3,
            });

            this.getCashfreeTransactionDetails();
          }
          // else{
          //   new CripNotice({
          //     title: "Oops! Something went wrong!",
          //     description: "Rest assured, your money is safe",
          //     type: "error",
          //     duration: 3,
          //   });
          // }
        });
      } catch (error) {
        console.error('Error initializing Cashfree SDK:', error);

        new CripNotice({
          title: 'Oops! Something went wrong!',
          description: 'Please try again',
          type: 'error',
          duration: 3,
        });
      }
    },

    getCashfreeTransactionDetails() {
      if (this.order_id) {
        this.isPageLoading = true; //page loader

        setTimeout(() => {
          serverAddr
            .get(`payment/v3/plan_details_from_order_id/${this.order_id}`)
            .then((response) => {
              // this.is_confirm_plan_purchase_dialog_visible = false;
              var plan_data = response.data.response;
              console.log(plan_data.data);

              if (plan_data.extra_info.module == 'PLAN_PURCHASED' && plan_data.data.plan == 'StockAnts Chat') {
                this.$store.commit('storePlanStatus', plan_data);
                this.$store.commit('commitQRCodePopup', false);
                if (plan_data.data.plan.length) {
                  this.$store.commit('storePaymentStatus', true);
                }
              }

              if (plan_data && plan_data.extra_info.transaction_status == 'SUCCESS' && plan_data.data.plan == 'StockAnts Chat') {
                this.$store.commit('commitChatPlanDetails', plan_data.data);
                this.saveSubscribedChatPlanDetails(plan_data.data);

                this.$store.commit('commitKycDialog', true);
              }

              this.isPageLoading = false; //page loader
            })
            .catch((error) => {
              console.log(error);

              this.isPageLoading = false; //page loader

              new CripNotice({
                title: 'Oops! Something went wrong!',
                description: 'Please try again',
                type: 'error',
                duration: 3,
              });
            });
        }, 2000);
      }
    },

    checkIsSessionOngoing() {
      let isActive = false;

      let session = JSON.parse(localStorage.getItem('userChatSession'));

      console.log('session', session);

      if (session && session.session_timeout) {
        const currentTime = new Date();
        const sessionEndTime = new Date(session.session_timeout);

        if (currentTime > sessionEndTime) {
          isActive = false;
        } else {
          isActive = true;
        }

        return isActive;
      }
    },
  },

  beforeDestroy() {
    console.log('destroying socket from expert list page');
    //   this.$socket.disconnect();
    clearInterval(this.timer);
    this.$socket.off('response');
  },

  computed: {
    filteredExperts() {
      let experts = [];

      if (this.searchTerm.trim()) {
        experts = this.experts.filter((expert) => expert.full_name.toLowerCase().includes(this.searchTerm.toLowerCase()));
      } else {
        experts = this.experts;
      }

      return experts;
    },

    isRequestTimeExpired() {
      let isExpired = false;

      if (this.timeWhenRequestSent) {
        const givenTime = this.timeWhenRequestSent; // Example of a specific date and time

        // Calculate the difference in milliseconds
        let timeDifference = this.currentTime - givenTime;

        // Convert 1 minute to milliseconds (1 * 60 * 1000)(Min * Sec * 1000)
        const requestedTimeInSec = 1 * 60 * 1000;

        // Check if the current time is greater than 15 sec after the given time
        if (timeDifference > requestedTimeInSec) {
          isExpired = true;
        } else {
          isExpired = false;
        }
      }
      return isExpired;
    },

    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    roomId() {
      return this.$store.state.room_id;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.ChatExpertList {
  margin-top: 60px;
  display: flex;
  height: calc(100vh - 70px);
  border-top: 1px solid #ececec;
  overflow-y: hidden;

  .expert-list-section {
    flex-grow: 1;
    padding: 20px 20px 40px 20px;
    overflow-y: auto;
    background-color: #f8f8f8;

    .search-input {
      margin-bottom: 20px;
      max-width: 270px;
      border-radius: 10px;

      .el-input__inner {
        border-radius: 10px;
      }
    }

    .search-icon {
      font-size: 16px;
      vertical-align: middle;
      position: absolute;
      right: 15px;
      color: #797979;
      top: 8px;
    }
  }

  .bottom-popup {
    bottom: 0 !important;
  }

  .start-chat-popup {
    .popup-content {
      padding: 20px 25px;
      text-align: center;

      /* Title Styling */
      .popup-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 0;
        color: #000;
      }

      /* Partition Line */
      .partition-line {
        width: 50px; // or 150px if preferred
        height: 1px;
        background-color: #000;
        margin: 0 auto 20px; // Center the line with auto margin
      }

      /* Button Group for Category Selection */
      .button-group {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 20px;
        gap: 20px;
        justify-content: center;

        .category-btn {
          padding: 15px;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          color: $text-muted;
          font-weight: 600;
          font-size: 14px;
          border: 1px solid transparent;
          width: 160px;

          &.active {
            background-color: #d8eaff;
            color: #2488ff;
            border: 1px solid #2488ff;
          }
        }
      }

      .agreement-text {
        display: flex;
        text-align: left;
        word-break: normal;

        p {
          margin: 4px 0 0;
          font-size: 10px;
          color: #000;
        }
      }

      /* Chat Button Styling */
      .chat-btn-container {
        .chat-btn {
          width: 120px;
          padding: 10px;
          background-color: #2488ff;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          margin-top: 20px;
          font-weight: 600;
          font-size: 12px;

          &:disabled {
            cursor: not-allowed;
          }

          &:hover:not(:disabled) {
            background-color: #2488ff;
          }
        }
      }
    }
  }

  .confirmation-popup {
    .popup-content .popup-title {
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 25px;
    }

    .btn-light-blue-borderd:hover {
      background: #ffff;
      color: $external-link-color;
      border: 1px solid $external-link-color;
    }

    .btn-light-blue-filled:hover {
      background: $external-link-color;
      color: #ffff;
      border: 1px solid $external-link-color;
    }

    p {
      color: #000;
      font-size: 10px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .expert-busy-btns {
      .el-button {
        font-size: 10px;
      }
    }
  }
}

@media screen and (max-width: 1284px) {
  .ChatExpertList {
    height: calc(100vh - 128px);
  }
}

@media screen and (max-width: 968px) {
  .ChatExpertList .chat-drawer {
    height: auto !important;
  }
}

@media (max-width: 450px) {
  .ChatExpertList .start-chat-popup .popup-content {
    .button-group .category-btn {
      width: 250px;
    }

    .popup-title {
      font-size: 16px;
    }
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.ChatExpertList {
  .expert-list-section {
    .search-input {
      .el-input__inner {
        border-radius: 20px;
      }
    }
  }

  .start-chat-popup {
    .el-dialog {
      width: 585px;
      border-radius: 10px;
    }

    .el-dialog__header {
      padding: 7px;
      background-color: #2488ff;
      border-radius: 10px 10px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }

    .close-icon {
      // width: 28px;
      position: absolute;
      right: 10px;
      top: 30px;
    }

    .popup-content {
      .checkbox-group {
        margin-bottom: 20px;
        text-align: left;

        .el-checkbox {
          margin-left: 10px;
        }
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #2488ff;
        border-color: #2488ff;
      }
      .el-checkbox__inner {
        border: 2px solid #2488ff !important;
        position: relative;
        top: 1px;
      }
    }
  }

  .confirmation-popup {
    .el-dialog {
      width: 260px !important;
      margin-top: 140px !important;
    }
  }

  .chat-initiated {
    .el-dialog {
      width: 250px;
    }

    .el-loading-spinner .path {
      stroke: #2488ff !important;
      stroke-width: 6px !important;
    }

    .popup-content {
      padding: 20px;

      .loading-div {
        height: 30px;
        margin-top: 10px;
      }

      h4 {
        color: #000;
        margin: 10px 0;
        font-size: 14px;
      }

      p {
        margin: 0;
        font-size: 12px;
      }
    }
  }

  .el-drawer__header {
    margin: 0;
    padding: 0;
  }

  .chat-drawer {
    .drawer-content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;

      .left-section {
        flex: 1;
        width: 60%;
        padding-right: 20px;

        .inner-content {
          width: 456px;
          margin-left: auto;
          margin-top: 30px;
        }

        .drawer-heading {
          font-size: 20px;
          font-weight: 700;
          color: #2488ff;
          margin: 0;
        }

        .drawer-subtext {
          font-size: 0.7rem;
          color: #666;
          margin: 0;
          font-style: italic;
        }

        .details-list {
          padding: 0;
          margin: 20px 0;

          .points {
            display: flex;
            font-size: 15px;
            margin: 10px 0;
            font-weight: 500;

            i {
              font-size: 20px;
              color: #2488ff;
              margin-right: 4px;
            }
          }
        }
      }

      .right-section {
        flex: 1;
        width: 350px;
        padding-left: 20px;

        .plan-price {
          font-size: 30px;
          font-weight: 600;
          text-align: center;

          span {
            font-size: 15px;
          }
        }
        .plan-price-sub {
          font-size: 12px;
          font-weight: 500;
          margin-top: 10px;
        }
        .end-gray-txt {
          font-size: 10px;
          color: #6c6c6c;
          margin-top: 10px;
        }
        .chat-note {
          font-size: 12px;
          font-weight: 500;
          text-align: left;
          margin: 10px 0 0;
        }
        .inner-content {
          width: 300px;
          margin: 0 auto;
        }

        .pricing-table {
          margin: 0 auto;

          .table-titles {
            font-size: 0.7rem;
            font-weight: 500;
            margin: 10px 0;
          }

          .pricing-row {
            display: flex;
            justify-content: space-between;
            padding: 10px;
            margin-bottom: 15px;
            border: 1px solid #ddd;
            border-radius: 8px;
            transition: background-color 0.3s;
            background-color: #fafafa;

            &:last-child {
              margin-bottom: 0;
            }

            &.active-row {
              background-color: #f0f8ff;
              border: 1px solid #2488ff;
              box-shadow: 0px 0px 6px 1px #c1c1c1;
            }

            .price {
              font-size: 0.9rem;
              font-weight: 600;
            }

            .duration {
              font-size: 0.7rem;
              color: $text-muted;
            }
          }

          .pricing-column {
            display: flex;
            align-items: center;

            .el-radio__label {
              color: #2488ff;
            }
          }
        }

        .full-width-btn {
          width: 100%;
          margin: 15px auto 0;
          background-color: #2488ff;
          color: white;
          font-weight: bold;
        }

        .agreement-checkbox {
          display: flex;
          align-items: baseline;

          .el-checkbox {
            margin-top: 7px;
            font-weight: 500;

            .is-checked .el-checkbox__inner {
              background-color: #2488ff;
              border-color: #2488ff;
            }
          }

          p {
            font-size: 10px;
            margin: 3px 0 0 7px;

            color: #000;
          }

          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: #000;
          }
        }
      }
    }

    .el-drawer {
      padding: 20px;
      padding-top: 0;
      z-index: 1001;
      overflow: auto;
      border-radius: 10px 10px 0 0;
      height: auto;
      max-height: calc(100vh - 20px);
    }
    .checkbox-group {
      margin-bottom: 20px;
      text-align: left;

      .el-checkbox {
        margin-left: 10px;
      }
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #2488ff;
      border-color: #2488ff;
    }
    .el-checkbox__inner {
      border: 2px solid #2488ff !important;
      position: relative;
      top: 1px;
    }
  }

  .bottom-drawer {
    .el-drawer.btt {
      height: 280px !important;
      // height: 325px !important;
      width: calc(100% - 310px);
      left: 290px;
      right: 0;
      bottom: 10px;
      border-radius: 10px 10px 0 0;

      i.el-dialog__close.el-icon.el-icon-close {
        display: none;
      }
    }
  }

  .top-drawer {
    .el-drawer.ttb {
      width: 500px;
      margin: auto;
      top: 45px;
      background-color: transparent;
      box-shadow: none;
    }

    .close-icon {
      font-size: 20px;
      position: absolute;
      top: 2px;
      right: 10px;
      color: #b9b9b9;
      width: 25px;
    }

    .el-icon-check {
      color: #079e3e;
      font-weight: bolder;
      border: 4px solid;
      border-radius: 50%;
      padding: 4px;
      background: #ffff;
      font-size: 18px;
      margin-right: 10px;
    }

    .main-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70px !important;
      border-radius: 0 0 10px 10px;
      padding: 10px 15px;
      background-color: #2488ff;
      color: #ffff;
      position: relative;
      top: 15px;

      .check-outer {
        .name {
          font-size: 13px;
          font-weight: 700;
        }

        .duration {
          font-size: 13px;
          font-weight: 500;
          margin-top: 3px;
        }
      }

      .waiting-time-section {
        display: flex;
        align-items: flex-start;

        i {
          font-size: 18px;
          font-weight: 500;
          margin-right: 8px;
        }

        .head {
          font-weight: 600;
          font-size: 13px;
          margin-top: 3px;
        }

        .sub-text {
          font-size: 10px;
          font-weight: 500;
        }
      }
    }
  }

  .banner-drawer {
    .el-drawer__open .el-drawer.btt {
      -webkit-animation: btt-drawer-in 0.3s 1ms;
      animation: btt-drawer-in 0.3s 1ms;
      background-color: transparent;
      box-shadow: none;
      min-height: 200px !important;
    }
  }

  @media (max-width: 1283px) {
    .bottom-drawer {
      .el-drawer.btt,
      .el-drawer.ttb {
        // height: 70% !important;
        width: calc(100% - 30px);
        left: 15px;
      }
    }

    .background-container {
      width: 100%;
      margin-right: 10px;
    }

    .chat-drawer {
      height: 30% !important;
    }
  }

  @media (max-width: 765px) {
    .chat-drawer {
      height: 55% !important;

      .drawer-content {
        flex-direction: column-reverse;

        .left-section {
          margin-top: 30px;
          padding-right: 0;
          width: 100%;
          .inner-content {
            margin: auto;
            width: 100%;
            text-align: center;
          }

          .details-list {
           margin: 10px auto;
            width: 300px;
          }
        }

        .right-section {
          padding: 0;
        }
      }
    }

    .bottom-drawer .el-drawer.btt {
      height: 420px !important;

      i.el-dialog__close.el-icon.el-icon-close {
        display: block;
        position: relative;
        top: 7px;
      }
    }

    .start-chat-popup .el-dialog {
      width: 95%;
    }

    .chat-initiated .el-dialog {
      width: 250px !important;
    }

    .background-container {
      width: 100%;
      margin-right: 10px;
      // margin-bottom: 60px;
    }
  }

  @media (max-width: 520px) {
    .top-drawer .el-drawer.ttb {
      width: 95%;
    }

    .bottom-drawer .el-drawer.btt {
      width: calc(100% - 10px) !important;
      left: 5px;
    }
  }

  @media (max-width: 457px) {
    .chat-drawer {
      .drawer-content .left-section,
      .drawer-content .right-section .inner-content,
      .drawer-content .right-section {
        width: 95%;
        padding: 0;
        margin: auto;
      }

      .drawer-content .left-section .inner-content {
        width: 95%;
        margin: auto;
        margin-top: 20px;
      }
    }

    .bottom-drawer {
      .el-drawer.btt,
      .el-drawer.ttb {
        padding-top: 0;
      }

      .el-drawer {
        // padding: 10px;
      }
    }
  }

  @media (max-width: 380px) {
    .top-drawer .el-drawer.ttb {
      width: 250px;
    }

    .top-drawer .main-div {
      flex-wrap: wrap;
      height: 130px !important;

      .waiting-time-section {
        justify-content: left !important;
        width: 100%;
        margin-top: 15px;
        margin-left: 42px;
      }
    }
  }
}
</style>
